module.exports = __webpack_public_path__ + "static/media/Group9259.e74eddc2.png";